import { render, staticRenderFns } from "./FileSettings.vue?vue&type=template&id=1abd6156&"
import script from "./FileSettings.vue?vue&type=script&lang=js&"
export * from "./FileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports